// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-red[data-v-cdd89674]{fill:#cd3b18}.icon-blue[data-v-cdd89674]{fill:#41b6e6}.project-card[data-v-cdd89674]{min-height:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
